import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

export default {
  actions: {
    async [actions.DO_CREATE_LOCATION]({ commit }, params) {
      const { data } = await HTTP.post('/locations', params);
      commit(mutations.SET_LOCATION, data.data.locations[0]);
      return data;
    },
    async [actions.DO_GET_LOCATIONS]({ commit }, params) {
      const { data } = await HTTP.get('/locations', { params });
      commit(mutations.SET_LOCATIONS, data.data.locations);
      return data;
    },
    async [actions.DO_UPDATE_LOCATION]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.patch(`/locations/${id}`, params);
      commit(mutations.SET_LOCATION, data.data.locations[0]);
      return data;
    },
  },
  getters: {
    [getters.GET_LOCATIONS]: state => state.locations,
  },
  mutations: {
    [mutations.SET_LOCATION](state, location) {
      state.location = location;
    },
    [mutations.SET_LOCATIONS](state, locations) {
      state.locations = locations;
    },
  },
  state: {
    location: {},
    locations: [],
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/location.js